
import { showVuePopup } from '../../utils/showVuePopup';
import Profile from '../../popup/Profile.vue';
import WalletDeposit from '../../popup/WalletDeposit.vue';
import { useAuthStore } from '../../stores/auth';
import { storeToRefs } from 'pinia';
import { openGameUrl, shouldAvoidNewTab } from '../../utils/openGameUrl';
import Register from '../../popup/Register.vue';
import Login from '../../popup/Login.vue';
import { formatCurrency } from '../../utils/currency';
import { useWebStore } from '../../stores/web';
import { onMounted, onUpdated, ref } from 'vue';
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast';
import { useSession } from '../../stores/session';
import { external } from '../../apis/external';

export default {
	name: 'PopupMainNavbar',
	components: {
		Button,
	},
	methods: { formatCurrency },
	setup() {
		const auth = useAuthStore()
		auth.hydrate()
		const {profile, isLoggedIn} = storeToRefs(auth);

		const web = useWebStore();
		web.hydrate()

		const session = useSession();

		const toast = useToast();

		window.addEventListener('pageshow', (e) => {
			const isBFCache = e.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
			if (isBFCache) {
				const url = sessionStorage.getItem('previous_page');
				if (url !== null) {
					window.location.href = url
				}
			}
		});

		onMounted(() => {
			if (isLoggedIn.value) {
				auth.fetchData();
			}
			web.fetchPrefix();
			web.fetchPrefixPermission();
			web.fetchManagerConfig();
		})

		const btnLoading = ref<boolean>(false);
		const btnClickProfile = async () => {
			session.set('navbar_primary', 'profile');
			await showVuePopup(Profile);
		}

		const btnClickWalletDeposit = async () => {
			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:deposit');
			await showVuePopup(WalletDeposit);
		}

		const btnClickRegister = async () => {
			await showVuePopup(Register, {}, {
				customClass: {
					popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-register.webp)] bg-size-[100%_100%] bg-center bg-transparent'
				}
			});
		}

		const btnClickLogin = async () => {
			await showVuePopup(Login, {}, {
				customClass: {
					popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-login-Mobile.webp)] bg-size-[120%_100%] md:bg-size-[100%_100%] bg-center bg-transparent',
				},
			});
		}

		const btnRefProfile = async () => {
			btnLoading.value = true;
			try {
				await auth.fetchData();
				toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'อัพเดตโปรไฟล์เรียบร้อยแล้ว', life: 3000 });
			} catch (error: any) {
				const message = error?.message || 'ไม่สามารถอัพเดตโปรไฟล์ได้';
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาด',
					detail: message,
					life: 3000,
				});
				console.error('Fetch profile error:', error);
			} finally {
				btnLoading.value = false;
			}
		};

		const btnClickLogout = async () => {
			if (!confirm('ต้องการออกจากระบบ ใช่ หรือ ไม่?')) return;

			try {
				await auth.logout();
				toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'ออกจากระบบสำเร็จ', life: 3000 });
			} catch (error: any) {
				const message = error?.message || 'ออกจากระบบไม่สำเร็จ';
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาด',
					detail: message,
					life: 3000,
				});
				console.error('Fetch profile error:', error);
			} finally {
				btnLoading.value = false;
			}
		}

		const btnTournament = async () => {
			// อยู่ใน LINE/Telegram หรือ WKWebView ฝังในแอปบน iOS (Telegram iOS ไม่ประกาศ
			// ตัวใน UA) → ห้ามจอง tab: window.open ของ In-App มัก "สำเร็จ" — คืน window
			// ที่ไม่แสดงผล — แล้วทำให้ openGameUrl ไม่เคยถูกเรียก ผู้ใช้จึงกดแล้วไม่เกิดอะไร
			const noNewTab = shouldAvoidNewTab();

			// นอก In-App ต้องจอง tab ตอนนี้ ตอนที่ยังอยู่ใน call stack ของการคลิก —
			// Safari/iOS ผูก window.open ไว้กับ user gesture และหลัง await gesture
			// หมดอายุแล้วจึงบล็อกเงียบ ๆ (Android Chrome ผ่อนปรนกว่า จึงเปิดได้
			// ทั้งที่โค้ดเดียวกัน)
			const tab = noNewTab ? null : window.open('', '_blank');

			try {
				const resp = await external.tournament()

				if (resp.code !== '0') throw new Error(resp.message);

				const url = resp.result?.url || window.location.origin;

				if (tab) {
					// ผู้ใช้ปิดแท็บเปล่าทิ้งระหว่างรอ = ยกเลิก อย่าลากแท็บที่เขายืนอยู่ตามไป
					if (tab.closed) return;

					// ตัดสายกลับ ไม่ให้เว็บปลายทางสั่ง opener.location ได้ (reverse tabnabbing)
					tab.opener = null;
					tab.location.href = url;
					return;
				}

				// ไม่มี tab: อยู่ใน In-App (ตั้งใจไม่จอง) หรือโดน popup blocker
				// → พาออก default browser ถ้าอยู่ใน LINE/Telegram ไม่งั้นเปิดในแท็บเดิม
				openGameUrl(url, (target) => { window.location.href = target });
			} catch (error: any) {
				tab?.close();
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาด',
					// ต้องเป็นสตริง — ส่ง error object ดิบเข้ามาทำให้ toast โชว์
					// โครงสร้าง object ให้ผู้ใช้เห็นแทนข้อความ
					detail: error?.message || String(error),
					life: 3000,
				});
			}
		}

		const paths: string[] = [
			'/',
		];

		const checkPaths = (): boolean => {
			const normalize = (path: string) => path.replace(/\/+$/, '');
			const currentPath = normalize(window.location.pathname);
			return paths.some(path => currentPath === normalize(path));
		};

		return {
			auth,
			profile,
			isLoggedIn,
			btnLoading,
			btnClickProfile,
			btnClickWalletDeposit,
			btnClickRegister,
			btnClickLogin,
			btnRefProfile,
			btnClickLogout,
			btnTournament,
			checkPaths,
		}
	}
}
